const CREATE_ACCOUNT_TAB_NAME = 'createAccount';
const SIGN_IN_ACCOUNT_TAB_NAME = 'signIn';
const FORGOT_PASSWORD_ACCOUNT_TAB_NAME = 'forgotPassword';
const RESET_PASSWORD_ACCOUNT_TAB_NAME = 'resetPassword';

export default {
  [CREATE_ACCOUNT_TAB_NAME]: {
    name: CREATE_ACCOUNT_TAB_NAME,
    modalTitle: 'Create account',
    modalHeading: 'Create Your Carvana Account',
    submitButtonText: 'Create My Account'
  },
  [SIGN_IN_ACCOUNT_TAB_NAME]: {
    name: SIGN_IN_ACCOUNT_TAB_NAME,
    modalTitle: 'Sign in',
    modalHeading: 'Hey there, welcome back.',
    submitButtonText: 'Sign In'
  },
  [FORGOT_PASSWORD_ACCOUNT_TAB_NAME]: {
    name: FORGOT_PASSWORD_ACCOUNT_TAB_NAME,
    externalName: 'forgotPassword',
    modalTitle: 'Forgot password',
    modalHeading: 'Forgot your password?',
    submitButtonText: 'Reset My Password'
  },
  [RESET_PASSWORD_ACCOUNT_TAB_NAME]: {
    name: RESET_PASSWORD_ACCOUNT_TAB_NAME,
    modalTitle: 'Reset password',
    modalHeading: 'Let\'s change it up.',
    submitButtonText: 'Change My Password'
  },
};
